import { render, staticRenderFns } from "./ag-radio-button.vue?vue&type=template&id=2677d55b&scoped=true"
import script from "./ag-radio-button.vue?vue&type=script&lang=js"
export * from "./ag-radio-button.vue?vue&type=script&lang=js"
import style0 from "./ag-radio-button.vue?vue&type=style&index=0&id=2677d55b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677d55b",
  null
  
)

export default component.exports